import { createRouter, createWebHistory } from 'vue-router'
import { useUIStore } from '@/stores/ui'
import { useVoterStore } from '@/stores/voter'
import Home from '@/views/Home.vue'

const router = createRouter({
  history: createWebHistory(),
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home,
    },
    {
      path: '/rooms',
      name: 'CreateRoom',
      component: () => import('@/views/CreateRoomView.vue'),
    },
    {
      path: '/join/:roomKey',
      name: 'JoinRoom',
      component: () => import('@/views/JoinRoomView.vue'),
      props: true,
    },
    {
      path: '/rooms/:roomKey',
      redirect: (to) => {
        return `/rooms/${to.params.roomKey}/estimationpoker`
      },
    },
    {
      path: '/rooms/:roomKey/estimationpoker',
      name: 'EstimationPoker',
      component: () => import('@/views/RoomView.vue'),
      props: true,
      beforeEnter: (to, _from, next) => {
        // Check if user has a valid voter session before entering room
        const voterStore = useVoterStore()
        const currentVoter = voterStore.currentVoter
        const roomKey = to.params.roomKey as string
        
        if (!currentVoter) {
          console.log('No voter session found, redirecting to join page')
          next(`/join/${roomKey}`)
        } else if (currentVoter.roomKey !== roomKey) {
          console.log('Voter belongs to different room, redirecting to join page')
          next(`/join/${roomKey}`)
        } else {
          next()
        }
      },
    },
    {
      path: '/rooms/:roomKey/confidencevote',
      name: 'ConfidenceVote',
      component: () => import('@/views/RoomView.vue'),
      props: true,
      beforeEnter: (to, _from, next) => {
        // Check if user has a valid voter session before entering room
        const voterStore = useVoterStore()
        const currentVoter = voterStore.currentVoter
        const roomKey = to.params.roomKey as string
        
        if (!currentVoter) {
          console.log('No voter session found, redirecting to join page')
          next(`/join/${roomKey}`)
        } else if (currentVoter.roomKey !== roomKey) {
          console.log('Voter belongs to different room, redirecting to join page')
          next(`/join/${roomKey}`)
        } else {
          next()
        }
      },
    },
    {
      path: '/rooms/:roomKey/retrospective',
      name: 'Retrospective',
      component: () => import('@/views/RoomView.vue'),
      props: true,
      beforeEnter: (to, _from, next) => {
        // Check if user has a valid voter session before entering room
        const voterStore = useVoterStore()
        const currentVoter = voterStore.currentVoter
        const roomKey = to.params.roomKey as string
        
        if (!currentVoter) {
          console.log('No voter session found, redirecting to join page')
          next(`/join/${roomKey}`)
        } else if (currentVoter.roomKey !== roomKey) {
          console.log('Voter belongs to different room, redirecting to join page')
          next(`/join/${roomKey}`)
        } else {
          next()
        }
      },
    },
    // Catch-all route for 404 - will be implemented in task 15.3
    {
      path: '/:pathMatch(.*)*',
      name: 'NotFound',
      component: () => import('@/views/NotFoundView.vue'),
    },
  ],
})

// Navigation guards for loading states (Requirement 12.5)
router.beforeEach((_to, _from, next) => {
  const uiStore = useUIStore()
  uiStore.setNavigating(true)
  next()
})

router.afterEach(() => {
  const uiStore = useUIStore()
  uiStore.setNavigating(false)
})

export default router